"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/free-mode";
import dynamic from "next/dynamic";
const Intro = dynamic(() => import("@/ui/Intro"));

function OnTheJobTraining({ courseSections }) {
  const rawItems =
    courseSections?.OnJobStudent ||
    courseSections?.attributes?.OnJobStudent ||
    [];

  const slides = rawItems
    ?.map((item, index) => {
      const media = item?.student_image;
      if (!media) return null;

      // student_image is single Media
      const src =
        media.formats?.medium?.url ||
        media.formats?.large?.url ||
        media.formats?.small?.url ||
        media.url;

      if (!src) return null;

      // company_logo is Multiple Media — pick first
      const logoMedia = Array.isArray(item.company_logo)
        ? item.company_logo[0]
        : item.company_logo;

      const companyLogoSrc =
        logoMedia?.formats?.thumbnail?.url ||
        logoMedia?.formats?.small?.url ||
        logoMedia?.url ||
        null;

      return {
        id: media.id || media.documentId || index,
        src,
        alt: media.alternativeText || item.student_name || "Student image",
        student_name: item.student_name || "",
        designation: item.designation || "",
        company_name: item.company_name || "",
        company_logo: companyLogoSrc,
      };
    })
    .filter(Boolean) || [];

  if (!slides.length) return null;

  return (
    <section className="w-full text-black space-y-2 mb-8">
      <div className="page-container py-[12px] md:py-[14px] mx-auto">
        <div className="flex items-center justify-between gap-4 mb-4">
          <Intro
            title="Students' Success Through OJL"
            description="Celebrating students who transformed classroom learning into real-world excellence through hands-on OJL experiences."
          />
        </div>

        <div className="relative overflow-hidden">
          <div className="px-4 sm:px-6 lg:px-8">
            <Swiper
              modules={[FreeMode, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.15}
              freeMode={{ enabled: true, momentum: false }}
              loop={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              speed={3000}
              breakpoints={{
                640: { slidesPerView: 1.5 },
                768: { slidesPerView: 2.2 },
                1024: { slidesPerView: 3.2 },
              }}
              style={{ overflow: "visible" }}
              className="py-2"
            >
              {slides.map((item, index) => (
                <SwiperSlide
                  key={`${item.id}-${index}`}
                >
                  <div className="placed-card w-[180px] sm:w-[180px] lg:w-[300px] flex-shrink-0 bg-white border border-[#CDE2EB] overflow-hidden flex flex-col">

                    {/* Portrait */}
                    <div className="relative w-full h-44 md:h-64 lg:h-72 overflow-hidden">
                      <Image
                        src={item.src}
                        alt={item.alt}
                        fill
                        sizes="260px"
                        className="object-cover object-top"
                        loading="lazy"
                      />
                      {/* Gradient + name + designation overlay */}
                      <div
                        className="absolute inset-0 flex flex-col justify-end px-3 py-3"
                        style={{
                          background:
                            "linear-gradient(180deg, rgba(8,30,45,0) 45%, rgba(8,30,45,0.82) 100%)",
                        }}
                      >
                        {item.student_name && (
                          <p className="text-white font-bold text-[15px] leading-tight line-clamp-1">
                            {item.student_name}
                          </p>
                        )}
                        {item.designation && (
                          <p className="text-white/80 text-[13px] leading-tight line-clamp-1">
                            {item.designation}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Company logo / name strip */}
                    {(item.company_logo || item.company_name) && (
                      <div className="flex items-center justify-center h-[40px] px-2 sm:px-4 border-t border-[#CDE2EB] bg-white mt-auto">
                        {item.company_logo ? (
                          <Image
                            src={item.company_logo}
                            alt={item.company_name || "Company logo"}
                            width={220}
                            height={80}
                            className="h-[30px] sm:h-[30px] w-auto object-contain"
                          />
                        ) : (
                          <p
                            className="text-xs md:text-sm leading-tight"
                            style={{ fontFamily: "saans-bold" }}
                          >
                            {item.company_name}
                          </p>
                        )}
                      </div>
                    )}

                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OnTheJobTraining;